import { FC, TimeHTMLAttributes } from 'react';
import { dateFormat, dateTimeFormat } from 'src/utils/date-time-format';
import { useMemoOne } from 'use-memo-one';

export type DateType = 'date' | 'date-time';

type Props = {
  value: string;
  type?: 'date' | 'date-time';
} & Omit<TimeHTMLAttributes<HTMLTimeElement>, 'dateTime'>;

export function getFormat(type: DateType) {
  switch (type) {
    case 'date':
      return dateFormat;
    case 'date-time':
      return dateTimeFormat;
  }
}

export const FormatDate: FC<Props> = ({ value, type = 'date', ...props }) => {
  const formatted = useMemoOne(() => {
    const date = new Date(value);
    return date.toLocaleString('de-DE', getFormat(type));
  }, [type, value]);

  return (
    <time dateTime={value} {...props}>
      {formatted}
    </time>
  );
};
